<template>
	<section class="products bg-light">
		<div class="container">
			<div class="row">
				<div
					data-aos="fade-up"
					data-aos-duration="1000"
					class="section-title"
				>
					<h2>نیمارکت</h2>
					<p>برترین محصولات را از نیمارکت خریداری نمایید</p>
				</div>
				<swiper class="content" :options="swiperOption">
					<swiper-slide
						v-for="(product, index) in products"
						:key="index"
						class="item col-6 col-lg-3 mobile"
						data-aos="fade-right"
					>
						<div class="inner">
							<div
								class="img"
								v-bind:style="{
									'background-image':
										'url(' +
										rootImagePath +
										product.imagePath +
										')'
								}"
							></div>
							<div class="details">
								<label>{{ product.name }}</label>
							</div>
						</div>
					</swiper-slide>
					<div class="swiper-button-prev" slot="button-prev"></div>
					<div class="swiper-button-next" slot="button-next"></div>
				</swiper>
			</div>
		</div>
	</section>
</template>
<script>
export default {
	props: {
		rootImagePath: {
			type: String
		},

		products: {
			type: Array
		}
	},

	data() {
		return {
			swiperOption: {
				loop: true,
				slidesPerView: "auto",
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev"
				}
			}
		};
	}
};
</script>
<style scoped>
.products {
	width: 100%;
	min-height: 100%;
	float: right;
	text-align: center;
	background-color: #fff;
	overflow: hidden;
}
.products .content {
	width: 100%;
	float: right;
	padding-bottom: 80px;
	position: relative;
}
.products .content .item {
	padding-top: 20px;
	padding-left: 10px;
	padding-right: 10px;
	transition: all 0.5s;
	height: 300px;
}
.products .content .item .inner {
	width: 100%;
	height: 100%;
	float: right;
	border-radius: 10px;
	position: relative;
	overflow: hidden;
	box-shadow: 0 1px 3px 0 rgba(221, 221, 221, 1);
}

.products .content .item .img {
	background-position: center center;
	background-size: cover;
	width: 100%;
	height: 100%;
	padding: 10px;
	transition: all 0.5s;
	border-radius: 10px;
}

.products .content .item .details {
	width: calc(100% - 40px);
	min-height: 50px;
	border-radius: 0 20px 20px 0;
	box-shadow: 0 1px 3px 0 rgba(221, 221, 221, 1);
	background: #fff;
	color: #000;
	bottom: 20px;
	left: -20px;
	padding-top: 15px;
	transition: all 0.5s;
	position: absolute;
	text-align: right;
	padding-right: 20px;
	opacity: 0;
}

.products .content .item:hover .img {
	transform: scale(1.05);
}

.products .content .item:hover .details {
	opacity: 1;
	left: 0px;
}

.products .content .item .details * {
	display: block;
	font-weight: bold;
}

.products .content .item .details label {
	font-size: 13px;
}
</style>
